var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "speech-settings-tab" },
    [
      _c("div", { staticClass: "tab-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.speechSettingsTitle")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("voiceagent.speechSettingsSubtitle")))]),
      ]),
      _vm._v(" "),
      _c(
        "a-form",
        { staticClass: "settings-form", attrs: { layout: "vertical" } },
        [
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.backgroundSound"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.backgroundSound") } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.ambient_sound,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "ambient_sound", $$v)
                        },
                        expression: "formData.ambient_sound",
                      },
                    },
                    _vm._l(_vm.backgroundSoundOptions, function (sound) {
                      return _c(
                        "a-select-option",
                        { key: sound.value, attrs: { value: sound.value } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(sound.label) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("voiceagent.backgroundSoundDescription")
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.ambient_sound
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t("voiceagent.backgroundSoundLevel"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "slider-container" },
                        [
                          _c("a-slider", {
                            staticClass: "volume-slider",
                            attrs: { min: 0, max: 1, step: 0.1 },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: _vm.formData.ambient_sound_volume,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "ambient_sound_volume",
                                  $$v
                                )
                              },
                              expression: "formData.ambient_sound_volume",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-input-number", {
                            attrs: { min: 0, max: 1, step: 0.1 },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: _vm.formData.ambient_sound_volume,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "ambient_sound_volume",
                                  $$v
                                )
                              },
                              expression: "formData.ambient_sound_volume",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("voiceagent.backgroundSoundLevelDescription")
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.speechBehavior")))]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.responsiveness") } },
                [
                  _c(
                    "div",
                    { staticClass: "slider-container" },
                    [
                      _c("a-slider", {
                        staticClass: "responsive-slider",
                        attrs: { min: 0, max: 1, step: 0.05 },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.responsiveness,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "responsiveness", $$v)
                          },
                          expression: "formData.responsiveness",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-input-number", {
                        attrs: { min: 0, max: 1, step: 0.05 },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.responsiveness,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "responsiveness", $$v)
                          },
                          expression: "formData.responsiveness",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("voiceagent.responsivenessDescription")) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("voiceagent.interruptionSensitivity"),
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "slider-container" },
                    [
                      _c("a-slider", {
                        staticClass: "sensitivity-slider",
                        attrs: { min: 0, max: 1, step: 0.05 },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.interruption_sensitivity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "interruption_sensitivity",
                              $$v
                            )
                          },
                          expression: "formData.interruption_sensitivity",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-input-number", {
                        attrs: { min: 0, max: 1, step: 0.05 },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.interruption_sensitivity,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "interruption_sensitivity",
                              $$v
                            )
                          },
                          expression: "formData.interruption_sensitivity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(
                            "voiceagent.interruptionSensitivityDescription"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.backchannelSection"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("voiceagent.backchannelDescription")) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.backchannelEnable") } },
                [
                  _c("a-switch", {
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.enable_backchannel,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "enable_backchannel", $$v)
                      },
                      expression: "formData.enable_backchannel",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(_vm.$t("voiceagent.backchannelEnableDescription"))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.enable_backchannel
                ? _c(
                    "div",
                    { staticClass: "backchannel-settings" },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t("voiceagent.backchannelFrequency"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "slider-container" },
                            [
                              _c("a-slider", {
                                staticClass: "frequency-slider",
                                attrs: { min: 0, max: 1, step: 0.1 },
                                on: { change: _vm.updateSettings },
                                model: {
                                  value: _vm.formData.backchannel_frequency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "backchannel_frequency",
                                      $$v
                                    )
                                  },
                                  expression: "formData.backchannel_frequency",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "slider-value" }, [
                                _vm._v(
                                  _vm._s(_vm.formData.backchannel_frequency)
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "voiceagent.backchannelFrequencyDescription"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: _vm.$t("voiceagent.backchannelWords"),
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                mode: "tags",
                                placeholder: _vm.$t(
                                  "voiceagent.backchannelWordsPlaceholder"
                                ),
                              },
                              on: { change: _vm.updateSettings },
                              model: {
                                value: _vm.formData.backchannel_words,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "backchannel_words",
                                    $$v
                                  )
                                },
                                expression: "formData.backchannel_words",
                              },
                            },
                            _vm._l(
                              _vm.defaultBackchannelWords,
                              function (word) {
                                return _c(
                                  "a-select-option",
                                  { key: word, attrs: { value: word } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(word) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "voiceagent.backchannelWordsDescription"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.noiseReductionSettings"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("voiceagent.denoisingSectionDescription")) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.denoisingMode") } },
                [
                  _c(
                    "div",
                    { staticClass: "radio-group-container" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          on: { change: _vm.updateSettings },
                          model: {
                            value: _vm.formData.denoising_mode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "denoising_mode", $$v)
                            },
                            expression: "formData.denoising_mode",
                          },
                        },
                        [
                          _c("div", { staticClass: "radio-option" }, [
                            _c(
                              "div",
                              { staticClass: "radio-header" },
                              [
                                _c(
                                  "a-radio",
                                  { attrs: { value: "noise-cancellation" } },
                                  [
                                    _c("span", { staticClass: "radio-label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("voiceagent.noiseCancellation")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "radio-description" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("voiceagent.noiseCancellationDesc")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-option" }, [
                            _c(
                              "div",
                              { staticClass: "radio-header" },
                              [
                                _c(
                                  "a-radio",
                                  {
                                    attrs: {
                                      value:
                                        "noise-and-background-speech-cancellation",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "radio-label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "voiceagent.noiseAndBackgroundSpeechCancellation"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tooltip",
                                  {
                                    attrs: {
                                      placement: "right",
                                      title: _vm.$t(
                                        "voiceagent.denoisingTvSpeechTooltip"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons info-icon",
                                      },
                                      [_vm._v("info_outline")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "radio-description" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "voiceagent.noiseAndBackgroundSpeechCancellationDesc"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.transcriptSettings"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.sttMode") } },
                [
                  _c(
                    "div",
                    { staticClass: "radio-group-container" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          on: { change: _vm.updateSettings },
                          model: {
                            value: _vm.formData.stt_mode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "stt_mode", $$v)
                            },
                            expression: "formData.stt_mode",
                          },
                        },
                        [
                          _c("div", { staticClass: "radio-option" }, [
                            _c(
                              "div",
                              { staticClass: "radio-header" },
                              [
                                _c("a-radio", { attrs: { value: "fast" } }, [
                                  _c("span", { staticClass: "radio-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("voiceagent.sttOptimizeFast")
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "radio-description" }, [
                              _vm._v(
                                _vm._s(_vm.$t("voiceagent.sttOptimizeFastDesc"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-option" }, [
                            _c(
                              "div",
                              { staticClass: "radio-header" },
                              [
                                _c(
                                  "a-radio",
                                  { attrs: { value: "accurate" } },
                                  [
                                    _c("span", { staticClass: "radio-label" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "voiceagent.sttOptimizeAccurate"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tooltip",
                                  {
                                    attrs: {
                                      placement: "right",
                                      title: _vm.$t(
                                        "voiceagent.sttAccurateTooltip"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons info-icon",
                                      },
                                      [_vm._v("info_outline")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "radio-description" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("voiceagent.sttOptimizeAccurateDesc")
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.boostedKeywords") } },
                [
                  _c("a-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      mode: "tags",
                      placeholder: _vm.$t(
                        "voiceagent.boostedKeywordsPlaceholder"
                      ),
                    },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.boosted_keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "boosted_keywords", $$v)
                      },
                      expression: "formData.boosted_keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("voiceagent.boostedKeywordsDescription")
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("voiceagent.enableSpeechNormalization"),
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-container" },
                    [
                      _c("a-switch", {
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.normalize_for_speech,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "normalize_for_speech", $$v)
                          },
                          expression: "formData.normalize_for_speech",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "right",
                            title: _vm.$t("voiceagent.speechNormTooltip"),
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons info-icon" }, [
                            _vm._v("info_outline"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(
                            "voiceagent.enableSpeechNormalizationDescription"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("voiceagent.enableTranscriptFormatting"),
                  },
                },
                [
                  _c("a-switch", {
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.enable_transcription_formatting,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "enable_transcription_formatting",
                          $$v
                        )
                      },
                      expression: "formData.enable_transcription_formatting",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(
                            "voiceagent.enableTranscriptFormattingDescription"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.reminderMessageSettings"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.reminderTriggerMs") } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 5000, max: 60000, step: 1000 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.reminder_trigger_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "reminder_trigger_ms", $$v)
                      },
                      expression: "formData.reminder_trigger_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t("voiceagent.reminderTriggerMsDescription")
                        ) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.maxReminders") } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, max: 5, step: 1 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.reminder_max_count,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "reminder_max_count", $$v)
                      },
                      expression: "formData.reminder_max_count",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(_vm.$t("voiceagent.maxRemindersDescription"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.pronunciationDictionary"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("voiceagent.pronunciationDictionaryHelp")) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.formData.pronunciation_dictionary,
                function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "pronunciation-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "pronunciation-row" },
                        [
                          _c("a-input", {
                            staticStyle: { width: "30%" },
                            attrs: { placeholder: _vm.$t("voiceagent.word") },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: item.word,
                              callback: function ($$v) {
                                _vm.$set(item, "word", $$v)
                              },
                              expression: "item.word",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "20%" },
                              on: { change: _vm.updateSettings },
                              model: {
                                value: item.alphabet,
                                callback: function ($$v) {
                                  _vm.$set(item, "alphabet", $$v)
                                },
                                expression: "item.alphabet",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "ipa" } },
                                [_vm._v("IPA")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "cmu" } },
                                [_vm._v("CMU")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("a-input", {
                            staticStyle: { width: "40%" },
                            attrs: {
                              placeholder: _vm.$t("voiceagent.phoneme"),
                            },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: item.phoneme,
                              callback: function ($$v) {
                                _vm.$set(item, "phoneme", $$v)
                              },
                              expression: "item.phoneme",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-button", {
                            staticStyle: { width: "10%" },
                            attrs: { type: "danger", icon: "delete" },
                            on: {
                              click: function ($event) {
                                return _vm.removePronunciation(index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-pronunciation" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "dashed", block: "" },
                      on: { click: _vm.addPronunciation },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("voiceagent.addPronunciation")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.update"] } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.saveChangesButton")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }